import { render, staticRenderFns } from "./TopicScroll.vue?vue&type=template&id=413d38ce&"
import script from "./TopicScroll.vue?vue&type=script&lang=js&"
export * from "./TopicScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports